import React from 'react';
import api from './../../services/api';
import './style.css';
import GetData from './GetData';

import {professional} from '../../services/api';
let apiProfessional = new professional();

var token = localStorage.getItem("user_token");

export default class TableHorarios extends React.Component {
    state = {
        dados: [],
    }
        

  componentDidMount() {
    this.loadData();
  }

  loadData = async () => {
    const request = await apiProfessional.getAllAgentExams(this.props.agent_id, [{header: 'status', value: 'Confirmada'}]);
    console.log(request);
    console.log(request.data);
    this.setState({ dados: request.data });
  };

  render() {
    return (
    <table>

        <tr>
            <th>Horários</th>
            <th>Status</th>
        </tr>

        { this.state.dados.map(row => 
          <tr>
              <td><GetData appointment_date={row.appointment_date}/></td>
              <td>Indisponível</td>
          </tr>)
        }
    </table>
    )
  }
}